module.exports = __webpack_public_path__ + "static/media/invoice-icon-active.0ed23bdc.svg";